import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const usersModule = {
  namespaced: true,
  state() {
    return {
      currentUser: null,
      users: [],
      usersPendingApproval: [],
      usersLoggedInToday: [],
      usersRejected: [],
      usersWithoutSepiaInfo: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default usersModule;
